import { render } from "./Bids.vue?vue&type=template&id=72c700bb"
import script from "./Bids.vue?vue&type=script&lang=js"
export * from "./Bids.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/auctions/Bids.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72c700bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72c700bb', __exports__)) {
    api.reload('72c700bb', __exports__)
  }
  
  module.hot.accept("./Bids.vue?vue&type=template&id=72c700bb", () => {
    api.rerender('72c700bb', render)
  })

}


export default __exports__